import React from 'react';

/**
 * Reusable Email Input component for Formik
 * Handles error styling and message display automatically
 */
const EmailInput = ({
    field, // { name, value, onChange, onBlur }
    form,
    label,
    placeholder = "Enter your email",
    ...props
}) => {
    const { errors, touched, setFieldValue } = form;
    const isError = errors[field.name] && touched[field.name];

    return (
        <div className="flex flex-col w-full">
            <div className="relative">
                <input
                    {...field}
                    {...props}
                    type="email"
                    id={field.name}
                    placeholder={placeholder}
                    onBlur={(e) => {
                        field.onBlur(e);
                        const trimmedValue = e.target.value.trim();
                        if (trimmedValue !== e.target.value) {
                            form.setFieldValue(field.name, trimmedValue);
                        }
                    }}
                    className={`w-full rounded-md border bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md transition-all
                        ${isError ? 'border-red-600' : 'border-[#e0e0e0]'}
                    `}
                />
            </div>

            {isError && (
                <p className="text-sm font-semibold text-red-500 mt-1">
                    {errors[field.name]}
                </p>
            )}
        </div>
    );
};

export default EmailInput;
